import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
class ChangeBehavior extends Behavior {
    constructor(plasm, appName, addMetadata) {
        super(plasm, appName, addMetadata);
        this.id = BehaviorType.change;
        this.iframeBehaviorListeners = [{ type: this.id, listener: this.handler }];
    }
}
export default ChangeBehavior;
